import { iCity } from "core/kangarooTypes/iCity";
import ApiService from "./api";
import { iPaginationResponse } from "core/kangarooTypes/iPaginationResponse";
import { iArea } from "core/kangarooTypes/iArea";
import { iPackageSize } from "core/kangarooTypes/iPackageSize";

export const getCites = (): Promise<iPaginationResponse<iCity>> => {
  return ApiService.fetchData({
    url: `cites?get_all=1`,
    method: "GET",
  });
};
export const getAreas = (
  cityId?: number
): Promise<iPaginationResponse<iArea>> => {
  return ApiService.fetchData({
    url: `areas?get_all=1`,
    method: "GET",
    params: {
      city_id: cityId,
    },
  });
};
export const getPackagesSize = (): Promise<
  iPaginationResponse<iPackageSize>
> => {
  return ApiService.fetchData({
    url: `sizes?get_all=1`,
    method: "GET",
  });
};
export const updateOrder = (
  data: {
    status?: string;
    driver_id?: number;
    note?: string;
    sort_index?: number;
  },
  orderId: string | number
): Promise<any> => {
  return ApiService.fetchData({
    url: `orders/${orderId}`,
    method: "PUT",
    data,
  });
};
